import React, { memo, useState } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { trackEvent } from '../../../utilities/analyticsUtilities';

const useStyles = makeStyles()((theme) => ({
    active: {
        backgroundColor: theme.palette.action.focus,
        '& .MuiListItemIcon-root': {
            color: theme.palette.primary.main
        }
    },
    nested: {
        paddingLeft: theme.spacing(4), 
    },
}));

const NavigationLink = ({ item }) => {
    const { path, label, bottomDivider, icon: Icon, analytics, children } = item;
    const location = useLocation();
    const { classes } = useStyles();
    
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        if (children) {
            setOpen(!open);
        } else if (analytics) {
            trackEvent(analytics.eventName, {
                category: analytics.category,
            });
        }
    };

    if (children) {
        return (
            <>
                <ListItemButton onClick={handleClick}>
                    {Icon && (
                        <ListItemIcon>
                            <Icon />
                        </ListItemIcon>
                    )}
                    <ListItemText primary={label} sx={{ color: 'white' }} />
                    {open ? <ExpandLess sx={{ color: 'white' }} /> : <ExpandMore sx={{ color: 'white' }} />}
                </ListItemButton>
                
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {children.map((child) => (
                            <ListItemButton
                                key={child.path}
                                component={RouterLink}
                                to={child.path}
                                className={location.pathname === child.path ? classes.active : classes.nested}
                                sx={{ pl: 4 }} 
                            >
                                {child.icon && (
                                    <ListItemIcon>
                                        <child.icon />
                                    </ListItemIcon>
                                )}
                                <ListItemText primary={child.label} sx={{ color: 'white' }} />
                            </ListItemButton>
                        ))}
                    </List>
                </Collapse>
                {bottomDivider && <><br /><Divider /><br /></>}
            </>
        );
    }

    const isActive = location.pathname === path;

    const CustomLink = React.forwardRef((props, ref) => (
        <li>
            <RouterLink ref={ref} to={path} {...props} />
            {bottomDivider && <> <br /><Divider /><br /></>}
        </li>
    ));

    return (
        <ListItemButton
            component={CustomLink}
            className={isActive ? classes.active : ''}
            onClick={handleClick}
        >
            {Icon && (
                <ListItemIcon>
                    <Icon />
                </ListItemIcon>
            )}
            <ListItemText primary={label} sx={{ color: 'white' }} />
        </ListItemButton>
    );
}

export default memo(NavigationLink);